/**
 * Invitation Component
 * 
 * Displays the formal wedding invitation.
 * Protected by session-based authentication.
 */

import React, { useEffect } from 'react';
import './Invitation.css';

// Import centralized auth utilities
import { useAuth, AuthGuard } from '../utils/auth';

function Invitation() {
  // Use centralized authentication hook
  const { isValidAccess, isLoading } = useAuth('/wiendvdiitnagtion');

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Apply invitation-specific body styling
    document.body.classList.add('invitation-body');

    return () => {
      // Remove invitation-specific body styling when component unmounts
      document.body.classList.remove('invitation-body');
    };
  }, []);

  return (
    <AuthGuard isLoading={isLoading} isValidAccess={isValidAccess}>
      <div className="app">
      <div className="hero">
        <div className="hero-text">
          <img src={`${process.env.PUBLIC_URL}/logo2.png`} alt="Wedding Logo" className="hero-logo" />
          <h1>Radhika & Vivek</h1>
        </div>
      </div>

      <div className="hero-text-section">
        <div className="hero-text-content">
          <img src={`${process.env.PUBLIC_URL}/logo2.png`} alt="Wedding Logo" className="hero-logo" />
          <h1>Radhika & Vivek</h1>
        </div>
      </div>

      <div className="invitation-content">
        <div className="invitation-main">
          <div className="invitation-text">
            <div className="invitation-title">
              <h1>Wedding Invitation</h1>
            </div>
            <div className="parents-invitation">
              <p>Dr. Sunita & Dr. Pramod Patil</p>
              <p>cordially invite you to celebrate the wedding of their beloved daughter</p>
            </div>
            
            <div className="couple-details">
              <div className="bride-details">
                <h2>Radhika</h2>
              </div>
              
              <div className="with-section">
                <h3>with</h3>
              </div>
              
              <div className="groom-details">
                <h2>Vivek</h2>
                <p>Son of Mrs. Rashmi & Mr. Sanjay Jain</p>
              </div>
            </div>
            
            <div className="journey-message">
              <p>as they begin a new chapter in their lives together</p>
            </div>
            
            <div className="wedding-ceremony-details">
              <h3>Wedding Ceremony</h3>
              <div className="ceremony-info">
                <p>Tuesday, 25th Nov 2025</p>
                <p>10:30 AM</p>
                <div className="venue-details">
                  <p>The Orchid Hotel Pune</p>
                  <p>Shree Shiv Chhatrapati Sports Complex</p>
                  <p>Bengaluru - Mumbai Hwy, adjacent Chatrapati Shivaji Maharaj Road</p>
                  <p>National Games Park, Balewadi</p>
                  <p>Pune, Maharashtra 411045, India</p>
                </div>
              </div>
            </div>

            <div className="family-compliments">
              <h3>With Best Compliments From</h3>
              <h4>The Patil & Jain Families</h4>
            </div>
          </div>

          <div className="invitation-decorative">
            <img src="/marigold.png" alt="Marigold decoration" className="invitation-flower top-left" />
            <img src="/jasmine.png" alt="Jasmine decoration" className="invitation-flower top-right" />
            <img src="/orchid.png" alt="Orchid decoration" className="invitation-flower bottom-left" />
            <img src="/gerbera.png" alt="Gerbera decoration" className="invitation-flower bottom-right" />
          </div>
        </div>


      </div>
    </div>
    </AuthGuard>
  );
}

export default Invitation;